import React, {useState} from "react";
import ReactGA from 'react-ga';
import {BrowserRouter as Router} from "react-router-dom";
import {Redirect, Route, Switch} from "react-router";
import {Button, Modal, Segment} from "semantic-ui-react";
import ResponsiveContainer from "./header/ResponsiveContainer";
import Main from "./main/Main";
import Forside from "./Forside";
import Footer from "./footer/Footer";
import NotFound from "./NotFound";
import ForKunder from "./forkunder/ForKunder";
import ScrollToTop from "./header/ScrollToTop";
import Produktet from "./produktet/Produktet";
import MoedeForberedelse from "./forkunder/MoedeForberedelse";
import TjekDinPension from "./forkunder/TjekDinPension";
import Helbredsoplysninger from "./forkunder/Helbredsplysninger";
import Begunstigelse from "./forkunder/Begunstigelse";
import BehandlingAfPersonoplysninger from "./forkunder/BehandlingAfPersonoplysninger";
import Skatteregler from "./forkunder/Skatteregler";
import LetsikringVedSygdom from "./produktet/LetsikringVedSygdom";
import LetsikringVedKritiskSygdom from "./produktet/LetsikringVedKritiskSygdom";
import LetsikringAfIndtaegtVedPension from "./produktet/LetsikringAfIndtaegtVedPension";
import LetsikringAfBarnVedDoed from "./produktet/LetsikringAfBarnVedDoed";
import LetsikringVedDoed from "./produktet/LetsikringVedDoed";
import AppConfig from '../app-config';

import {Provider} from "react-redux";
import Investering from "./produktet/Investering";
import BlivKunde from "./blivkunde/BlivKunde";
import OmLetpension from "./omletpension/OmLetpension";
import Medarbejdere from "./omletpension/Medarbejdere";
import Bestyrelse from "./omletpension/Bestyrelse";
import Jobopslag from "./omletpension/Jobopslag";
// import Nyheder from "./omletpension/Nyheder";
import PrivatlivOgCookies from "./PrivatlivOgCookies";
import Faq from "./Faq";
import OmkostningerStandard from "./produktet/OmkostningerStandard";
import OmkostningerUdvidet from "./produktet/OmkostningerUdvidet";
import appRoutes from "../routes/appRoutes";
import Direktion from "./omletpension/Direktion";

import rg4js from 'raygun4js';
import LetsikringAfHelbred from './produktet/LetsikringAfHelbred';
import BrugDinForsikring from "./BrugDinForsikring";
import Klima from "./Klima";

const setCookie = (cname, cvalue, exdays) => {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

const App = props => {
    const {store} = props;

    let cookiesPreviouslyAccepted;
    let nytDesignPreviouslyAccepted;

    if (window.localStorage) {
        cookiesPreviouslyAccepted = (window.localStorage.getItem('cookiesAccepted') === 'true');
        nytDesignPreviouslyAccepted = (window.localStorage.getItem('nytDesignAccepted') === 'true');
    } else {
        cookiesPreviouslyAccepted = (getCookie('cookiesAccepted') === 'true');
        nytDesignPreviouslyAccepted = (getCookie('nytDesignAccepted') === 'true');
    }

    const [cookiesAccepted, setCookiesAccepted] = useState(cookiesPreviouslyAccepted);
    const [nytDesignAccepted, setNytDesignAccepted] = useState(nytDesignPreviouslyAccepted);

    const acceptCookies = () => {
        if (window.localStorage)
            window.localStorage.setItem('cookiesAccepted', "true");
        else
            setCookie('cookiesAccepted', true, 365);
        setCookiesAccepted(true);
    }

    const acceptNytDesign = () => {
        if (window.localStorage)
            window.localStorage.setItem('nytDesignAccepted', "true");
        else
            setCookie('nytDesignAccepted', true, 365);
        setNytDesignAccepted(true);
    }

    ReactGA.initialize('UA-6738378-1');

    return (
        <Provider store={store}>
            <Router>
                <ScrollToTop>
                    <ResponsiveContainer>
                        <Main>
                            <Route path="/" render={({location}) => {
                                if (AppConfig.raygunApiKey) {
                                    rg4js('trackEvent', {type: 'pageView', path: location.pathname + location.search});
                                }
                                if (AppConfig && AppConfig.env === 'prod') {
                                    if (typeof window.ga === 'function') {
                                        ReactGA.pageview(window.location.pathname + window.location.search);
                                    }
                                }
                                return null;
                            }}/>
                            <Switch>
                                <Route exact path={appRoutes.ROOT} component={Forside}/>
                                <Route exact path={appRoutes.FOR_KUNDER} component={ForKunder}/>
                                <Route path={appRoutes.TJEK_DIN_PENSION} component={TjekDinPension}/>
                                <Route path={appRoutes.BRUG_DIN_FORSIKRING} component={BrugDinForsikring}/>
                                <Route path={appRoutes.MOEDEFORBEREDELSE} component={MoedeForberedelse}/>
                                <Route path={appRoutes.HELBREDSOPLYSNINGER} component={Helbredsoplysninger}/>
                                <Route path={appRoutes.BEGUNSTIGELSE} component={Begunstigelse}/>
                                <Route path={appRoutes.BEHANDLING_AF_PERSONOPLYSNINGER}
                                       component={BehandlingAfPersonoplysninger}/>
                                {/*Dette link benyttes fra aftalebeviset. Må ikke fjernes*/}
                                <Route path="/personoplysninger" component={BehandlingAfPersonoplysninger}/>
                                {/*Dette link er ved en fejl udsendt i et brev. Må ikke fjernes foreløbig*/}
                                <Route path="/forkunderbehandlingafpersonoplysninger"
                                       component={BehandlingAfPersonoplysninger}/>
                                <Route path={appRoutes.SKATTEREGLER} component={Skatteregler}/>
                                <Route exact path={appRoutes.PRODUKTET} component={Produktet}/>
                                <Route path={appRoutes.LETSIKRING_VED_SYGDOM} component={LetsikringVedSygdom}/>
                                <Route path={appRoutes.LETSIKRING_VED_KRITISK_SYGDOM}
                                       component={LetsikringVedKritiskSygdom}/>
                                <Route path={appRoutes.LETSIKRING_AF_INDTAEGT_VED_PENSION}
                                       component={LetsikringAfIndtaegtVedPension}/>
                                <Route path={appRoutes.LETSIKRING_AF_BARN_VED_DOED}
                                       component={LetsikringAfBarnVedDoed}/>
                                <Route path={appRoutes.LETSIKRING_AF_HELBRED} component={LetsikringAfHelbred}/>
                                <Route path={appRoutes.LETSIKRING_VED_DOED} component={LetsikringVedDoed}/>
                                <Route path={appRoutes.OMKOSTNINGER} component={OmkostningerStandard}/>
                                <Route path={appRoutes.OMKOSTNINGER_UDVIDET} component={OmkostningerUdvidet}/>
                                <Route exact path={appRoutes.INVESTERING}>
                                    <Redirect to={appRoutes.INVESTERING_AFKAST}/>
                                </Route>
                                <Route path={appRoutes.INVESTERING_AFKAST} component={Investering}/>
                                <Route path={appRoutes.INVESTERING_PROFILER} component={Investering}/>
                                <Route path={appRoutes.INVESTERING_FONDE} component={Investering}/>
                                <Route path={appRoutes.INVESTERING_KUNDEKAPITAL} component={Investering}/>
                                <Route path={appRoutes.INVESTERING_KLIMA} component={Investering}/>
                                <Route exact path={appRoutes.BLIV_KUNDE} component={BlivKunde}/>
                                <Route exact path={appRoutes.OM_LETPENSION} component={OmLetpension}/>
                                <Route path={appRoutes.MEDARBEJDERE} component={Medarbejdere}/>
                                <Route path={appRoutes.DIREKTION} component={Direktion}/>
                                <Route path={appRoutes.BESTYRELSE} component={Bestyrelse}/>
                                <Route path={appRoutes.JOBOPSLAG} component={Jobopslag}/>
                                {/*<Route path={appRoutes.NYHEDER} component={Nyheder}/>*/}
                                <Route exact path={appRoutes.PRIVATLIV_OG_COOKIES} component={PrivatlivOgCookies}/>
                                <Route exact path={appRoutes.KONTAKT}>
                                    <Redirect to={appRoutes.FAQ}/>
                                </Route>
                                <Route exact path={appRoutes.FAQ} component={Faq}/>
                                <Route exact path={appRoutes.KLIMA} component={Klima}/>
                                <Route component={NotFound}/>
                            </Switch>

                            {!cookiesAccepted &&
                            <Segment inverted tertiary style={{backgroundColor: '#f6f0e7'}}>
                                <div style={{float: "right", marginLeft: 50, marginTop: 30}}>
                                    <Button color="teal" onClick={acceptCookies}>Ok</Button>
                                </div>
                                <div style={{color: "black", padding: 16, paddingRight: 100}}>
                                    Vi bruger cookies på hjemmesiden for at måle trafikken på siden og for at forbedre
                                    brugeroplevelsen. Ved at bruge vores hjemmeside
                                    accepterer du brugen af cookies til disse formål. Du kan læse mere om cookies,
                                    herunder hvordan du slår dem fra, under <a className="link"
                                                                               href="/privatlivogcookies">”Privatliv og
                                    cookies”</a>.
                                </div>
                            </Segment>
                            }

                            <Modal
                                open={!nytDesignAccepted}
                            >
                                <Modal.Header >Hej</Modal.Header>
                                <Modal.Content style={{ color:'#000000ff'}}>
                                    Vi har fået nyt design.
                                    Derfor ser vores hjemmeside ikke ud, som den plejer.
                                    Men indholdet på siden er det samme som før.
                                    Vi håber du kan lide vores nye udtryk😊
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button primary onClick={acceptNytDesign}>OK</Button>
                                </Modal.Actions>
                            </Modal>

                        </Main>
                        <Footer/>
                    </ResponsiveContainer>
                </ScrollToTop>
            </Router>
        </Provider>
    );
}

export default App;
